import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_3 = { class: "custom" }
const _hoisted_4 = {
  key: 0,
  class: "badge badge-light-primary"
}
const _hoisted_5 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "fas fa-ellipsis-h" }, null, -1)
const _hoisted_7 = { class: "menu-item-wrapper" }
const _hoisted_8 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-edit" })
], -1)
const _hoisted_10 = {
  key: 1,
  class: "menu-item"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-trash" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableContentLoader = _resolveComponent("TableContentLoader")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.loader)
      ? (_openBlock(), _createBlock(_component_TableContentLoader, { key: 0 }))
      : (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_Table, {
            columns: _ctx.columns,
            rows: _ctx.shopFooter,
            padding: 3,
            loading: _ctx.loader
          }, {
            "cell-categories": _withCtx(({row:item}) => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(JSON.parse(item?.categories), (category, index) => {
                return (_openBlock(), _createBlock("span", {
                  key: index,
                  class: "category"
                }, _toDisplayString(category?.name), 1))
              }), 128))
            ]),
            "cell-status": _withCtx(({row:item}) => [
              _createVNode("div", _hoisted_3, [
                (item?.status == 1)
                  ? (_openBlock(), _createBlock("span", _hoisted_4, _toDisplayString(_ctx.$t('message.ACTIVE')), 1))
                  : (_openBlock(), _createBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('message.INACTIVE')), 1))
              ])
            ]),
            "cell-actions": _withCtx(({row:item}) => [
              _createVNode("button", {
                class: "action-btn",
                type: "button",
                onClick: ($event: any) => (_ctx.dropdownHandler(_ctx.activeIndex, item?.id))
              }, [
                _hoisted_6,
                _createVNode("div", {
                  class: ["dropdown-menu dropdown-menu-end action-dropdown", { active: _ctx.activeIndex === item?.id }]
                }, [
                  _createVNode("div", _hoisted_7, [
                    (_ctx.$can('edit_shop_footer'))
                      ? (_openBlock(), _createBlock("div", _hoisted_8, [
                          _createVNode("a", {
                            onClick: ($event: any) => (_ctx.editShopFooter(item)),
                            class: "menu-link me-1"
                          }, [
                            _hoisted_9,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('message.EDIT')), 1)
                          ], 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.$can('delete_shop_footer'))
                      ? (_openBlock(), _createBlock("div", _hoisted_10, [
                          _createVNode("a", {
                            onClick: ($event: any) => (_ctx.deleteShopFooter(item.id)),
                            class: "menu-link me-1"
                          }, [
                            _hoisted_11,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('message.DELETE')), 1)
                          ], 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 2)
              ], 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["columns", "rows", "loading"])
        ]))
  ]))
}